import React, { useEffect } from "react";
import {
  Box,
  Container,
  Divider,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import Header from "../components/common/Header";
import CustomBox from "../components/common/CustomBox";
import Info from "../components/common/Info";
import Input from "../components/Base/Input";
import SubmitButton from "../components/common/SubmitButton";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Config from "../Config";
import LoadingDots from "../components/Lottie/LoadingDots";
import Backdrop from "../components/common/Backdrop";
// import useRazorpay from "../utils/useRazorPay";
import { apis } from "../services/apiService";
import usePluralPay from "../utils/usePluralPay";
import IngenicoPaymentGateway from "../utils/IngenicoPaymentGateway";
import { loggerStore, onlyNumeric, twoDecimal } from "../utils/utils";
import styles from "../Style/Modules/customerSuccess.module.css";
import "../Style/Theme/index.css";
export default function CustomerSuccess() {
  let location = useLocation();
  window.history.forward();
  let timer = 0;
  const navigate = useNavigate();
  const { openIngenicoPayScreen } = IngenicoPaymentGateway();
  const [payableAmtDetail, setPayableAmtDetail] = useState();
  const [radioVal, setRadioVal] = useState("");
  const { pluralcreateOrder, openPlural } = usePluralPay();
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [EMsg, setEMsg] = useState();
  const [addamountErr, setAddAmountErr] = useState("");
  const [addition, setAddition] = useState(0);
  const [mockAddition, setMockAddition] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  // const { razorPaycreateOrder, openRazorPay } = useRazorpay();

  useEffect(() => {
    if (paymentStatus && Object?.keys(paymentStatus)?.length > 0) {
      let stateDataObj = {
        referenceno: paymentStatus?.arNumber || paymentStatus?.reference_id,
        amount: addition,
        paidamount: addition,
        paymentstatus:
          paymentStatus?.status !== "Paid"
            ? "Payment Failed"
            : paymentStatus.status,
      };

      if (paymentStatus?.status === "Paid") {
        let navigateURL = "/PaymentSuccess";
        navigate(navigateURL, { state: { ...stateDataObj } });
      }
    }
    return () => {
      setPaymentStatus({});
    };
  }, [paymentStatus?.status, EMsg]);

  //start for plural payment
  const callPluralPayAPI = async () => {
    try {
      let createOrderRes = await pluralcreateOrder(
        {
          mobile: payableAmtDetail?.mn,
          vleId: payableAmtDetail?.vleId,
          amount: addition,
        },
        setLoading,
        Config.RepaymentUrl + "PluralPayment/CreatePluralPaymentOrder",
        "Repayement"
      );
      const createOrderResponse = {
        type: "RP",
        vleId: payableAmtDetail?.vleId,
        cOPluralOrderID: createOrderRes?.successResult?.plural_order_id,
        channelId: createOrderRes?.successResult?.channelId,
        paymentMode: createOrderRes?.successResult?.paymentMode,
        countryCode: createOrderRes?.successResult?.countryCode,
        emailId: createOrderRes?.successResult?.emailId,
        theme: createOrderRes?.successResult?.theme,
        showSavedCardsFeature:
          createOrderRes?.successResult?.showSavedCardsFeature,
        appID: location.state.AppId,
        mobileNumber: createOrderRes?.successResult?.mobileNumber,
        amount: addition,
        orderToken: createOrderRes?.successResult?.token,
        arNumber: createOrderRes?.successResult?.arnumber,
        merchant_order_id: createOrderRes?.successResult?.merchant_order_id,
      };
      if (
        createOrderRes?.successResult !== null &&
        createOrderRes?.failedResult === null
      ) {
        await openPlural(
          createOrderResponse,
          setLoading,
          setPaymentStatus,
          setEMsg,
          "Repayement",
          setRadioVal
        );
      }
    } catch (error) {
      let errorMsg = JSON?.parse(error?.message);
      loggerStore(
        location.state.AppId,
        `Plural repayment fail to generate request data for RP = ${JSON?.stringify(
          errorMsg
        )}`,
        "error"
      );
    }
  };
  //end for plural payment

  // // start for razorpay
  // const callrazorPayAPI = async () => {
  //   let createOrderRes = await razorPaycreateOrder(
  //     {
  //       mno: payableAmtDetail?.mn,
  //       cno: payableAmtDetail?.vleId,
  //       amt: addition,
  //       em: payableAmtDetail?.em,
  //       type: "RP",
  //     },
  //     setLoading,
  //     Config.RepaymentUrl + "Payment/RePayment",
  //     "Repayement"
  //   );
  //   if (createOrderRes && Object.keys(createOrderRes).length > 0) {
  //     await openRazorPay(
  //       createOrderRes,
  //       addition,
  //       {
  //         mno: payableAmtDetail?.mn,
  //         cno: payableAmtDetail?.vleId,
  //         utr: "",
  //         amt: addition,
  //         type: "RP",
  //       },
  //       payableAmtDetail?.mn,
  //       setLoading,
  //       setPaymentStatus,
  //       Config.RepaymentUrl + "Payment/RePaymentStatus",
  //       "Repayement"
  //     );
  //   }
  // };
  // // end for razorpay

  // start Ingenico Payment request data
  useEffect(() => {
    //this effect call when ingenico payment is failed
    if (location?.state?.err) {
      setEMsg(location?.state?.err);
      setRadioVal("");
    }
  }, [location?.state?.err]);

  const getIngenicoPayDetail = async () => {
    try {
      const reqData = {
        mno: payableAmtDetail?.mn,
        cno: payableAmtDetail?.vleId,
        amt: addition,
        // em: payableAmtDetail?.em,
        em: "",
        type: "RP",
      };
      let resp = await apis.postApi(
        Config.RepaymentUrl +
          // "PluralPaymentController/GetIngenicoPaymentDetails",
          "PaymentController/GetIngenicoPaymentDetails",
        reqData
      );
      let result = await resp.json();
      if (resp.status === 200) {
        result.data.type = "RP";
        setLoading(false);
        return result?.data;
      }
    } catch (error) {
      let errorMsg = JSON?.parse(error?.message);
      setLoading(false);
      // console.log("error--------", errorMsg);
      setEMsg(errorMsg?.statusMessage);
      loggerStore(
        payableAmtDetail?.vleId,
        `Ingenico repayement  facing issue while generating request data error for RP = ${JSON?.stringify(
          errorMsg
        )}`,
        "error"
      );
      return false;
    }
  };
  // end Ingenico Payment request data
  // start handle on submit click
  const handleclick = async (event) => {
    event.preventDefault();
    setIsError(false);
    if (loading === false) {
      setLoading(true);
      if (radioVal === "pluralPay") {
        await callPluralPayAPI();
      } else if (radioVal === "ingenicoPay") {
        const ingenicoPayDetail = await getIngenicoPayDetail();
        if (ingenicoPayDetail) {
          openIngenicoPayScreen(ingenicoPayDetail);
        } else {
          setAddAmountErr(
            "Their is an issue with payment gateway please try again after some time"
          );
        }
        // openIngenicoPayScreen(await getIngenicoPayDetail());
      }
      // else {
      //   await callrazorPayAPI();
      //   setLoading(false);
      // }
    }
  };
  // end handle on submit click

  const changeAddition = (e) => {
    setAddition(e.target.value);
    setAddAmountErr("");
    setEMsg("");
    if (e?.target?.value && !twoDecimal(e?.target?.value)) {
      setAddAmountErr("Only numbers and upto 2 decimals are allowed");
    } else if (e?.target?.value > parseFloat(mockAddition)) {
      setAddAmountErr(
        `Enter Amount is greater than available balance ${mockAddition}`
      );
    } else {
      setAddAmountErr("");
    }
  };

  // start on page load this effect is called
  useEffect(() => {
    const getPayableAmtData = async () => {
      if (location?.state?.mn) {
        setLoading(true);
        try {
          const resp = await apis.getApiWithCustomHeader(
            `${Config.RepaymentUrl}PaymentController/PayableToCustomer?MN=${location?.state?.mn}`
          );
          const result = await resp?.json();
          if (resp.status === 200) {
            setLoading(false);
            setPayableAmtDetail(result?.data);
            const payableAmt = (
              parseFloat(result?.data?.oi.toFixed(2)) +
              parseFloat(result?.data?.op.toFixed(2)) +
              parseFloat(result?.data?.oc.toFixed(2))
            ).toFixed(2);
            setAddition(payableAmt);
            setMockAddition(payableAmt);
          }
        } catch (error) {
          const errorResult = JSON?.parse(error?.message);
          setLoading(false);
          loggerStore(
            location?.state?.AppId,
            `repayment amount facing issue while getting total amount to pay for RP = ${JSON?.stringify(
              errorResult
            )}`,
            "error"
          );
        }
      }
    };
    getPayableAmtData();
  }, [location?.state?.mn]);

  useEffect(() => {
    setEMsg("");
    // location?.state?.err
  }, []);

  const handleChange = (e) => {
    setEMsg("");
    setRadioVal(e.target.value);
  };

  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header
          showBar={true}
          step={3}
          disabledBackBtn={true}
          // showLogoutBtn={false}
        />
        <br />
        <br />
        <br />
        <Box mb={-2}>
          <CustomBox className="repayment_Th">
            <Info title="Anchor Name" data={payableAmtDetail?.an} />
            <Info title="Customer name" data={payableAmtDetail?.cn} />
          </CustomBox>
        </Box>
        <Box mb={-2}>
          <CustomBox className="repayment_Th">
            <Box className={styles.customerSuccessBox}>
              <Info title="Tenure" data={payableAmtDetail?.tenure} />
              <Info
                title="Total Limit"
                data={payableAmtDetail?.t_LIM?.toFixed(2)}
              />
              <Info
                title="Available Limit"
                data={payableAmtDetail?.a_LIM?.toFixed(2)}
              />
            </Box>
            <Box className={styles.customerSuccessBox1}>
              <Info title="ROI" data={payableAmtDetail?.roi} />
              <Info
                title="Penalty ROI"
                data={payableAmtDetail?.proi}
                isLast={true}
              />
            </Box>
          </CustomBox>
        </Box>
        <Box mb={-2}>
          <CustomBox className="repayment_Th">
            <Box className={styles.customerSuccessBox2}>
              <Info
                title="Total Outstanding Principle"
                data={payableAmtDetail?.op?.toFixed(2)}
              />
              <Info
                title="Total Outstanding Interest"
                data={payableAmtDetail?.oi?.toFixed(2)}
              />
              <Info
                title="Total Outstanding Charges"
                data={payableAmtDetail?.oc?.toFixed(2)}
                isLast={true}
              />
            </Box>
          </CustomBox>
        </Box>
        <Box mb={-2}>
          <CustomBox className="repayment_Th">
            <Box className={styles.customerSuccessBox2}>
              <Info
                title="Total Overdue Principle"
                data={payableAmtDetail?.odp?.toFixed(2)}
              />
              <Info
                title="Total Overdue Interest"
                data={payableAmtDetail?.odi?.toFixed(2)}
              />
              <Info
                title="Total Overdue Charges"
                data={payableAmtDetail?.odc?.toFixed(2)}
                isLast={true}
              />
            </Box>
          </CustomBox>
        </Box>
        <Input
          mb={3}
          type="text"
          autoComplete="off"
          name="PayableAmount"
          label="Payable Amount"
          value={addition}
          onChange={(e) => changeAddition(e)}
        />
        {EMsg && (
          <Box mb={1} mt={-3} ml={0} textAlign={"center"}>
            <Typography
              variant="p"
              color="subtitle"
              className="errorMsg_Th"
              sx={{ color: "red", textAlign: "center" }}
            >
              {EMsg}
              <br />
            </Typography>
          </Box>
        )}
        {addamountErr && (
          <Box mb={1} mt={-3} ml={0} textAlign={"center"}>
            <Typography
              variant="p"
              color="subtitle"
              className="errorMsg_Th"
              sx={{ color: "red", textAlign: "center" }}
            >
              {addamountErr}
              <br />
            </Typography>
          </Box>
        )}
        <Box className={`${styles.customerSuccessBox3}`} sx={{ mb: 13 }}>
          <Paper className={`${styles.customerSuccessPaper} repayment_Th`}>
            <Typography className="pfTxt_Th">
              {/* sx={{ color: "blue" }}>  */}
              Please select the payment gateway
            </Typography>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={radioVal}
              onChange={handleChange}
              sx={{
                // backgroundColor: "red",
                m: "10px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Box className={styles.customerSuccessBox4}>
                <FormControlLabel
                  disabled
                  value="pluralPay"
                  control={<Radio />}
                  // label="Plural Pay"
                  label={
                    <p>
                      Plural Pay
                      <br />
                      (coming soon...)
                    </p>
                  }
                />
              </Box>
              <Divider
                orientation="vertical"
                variant="middle"
                flexItem
                sx={{ backgroundColor: "black" }}
              />
              <Box className={styles.customerSuccessBox4}>
                <FormControlLabel
                  // value="razorPay"
                  value="ingenicoPay"
                  control={<Radio />}
                  // label="Razor Pay"
                  label="Ingenico Pay"
                />
              </Box>
            </RadioGroup>
          </Paper>
        </Box>

        {/* <SubmitButton hasNote="No" onClick={handleclick} disabled={loading} /> */}
        <form onSubmit={handleclick}>
          <SubmitButton
            hasNote="No"
            disabled={loading || !radioVal || EMsg || addamountErr || !addition}
            repaymentBtn="RepaymentBtn"
          />
        </form>
        {loading && (
          <Backdrop ax="center">
            <LoadingDots />
          </Backdrop>
        )}
      </Container>
    </>
  );
}
